import { render, staticRenderFns } from "./ClientCentricityMain.vue?vue&type=template&id=478c79a6"
import script from "./ClientCentricityMain.vue?vue&type=script&lang=js"
export * from "./ClientCentricityMain.vue?vue&type=script&lang=js"
import style0 from "./ClientCentricityMain.vue?vue&type=style&index=0&id=478c79a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports